export default "__VITE_PUBLIC_ASSET__41b8a609__"